<style scoped lang="less">
	.titles{
		width: 100%;
		height: 3rem;
		line-height: 3rem;
		margin: 1rem 0 0 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.titleleft{
			display: flex;
			p{
				font-size: 1.6rem;
				margin-right: 0.6rem;
				color: #000;
			}
			span{
				color: #20252A;
				margin-top: 0.4rem;
			}
		}
	}
	
	


</style>
<template>
	<div class="d-none d-sm-block">
		<div class="titles" >
			<div class="titleleft">
				<p>{{titlename}}</p>
				<span>{{titlecontent}}</span>
			</div>
			<div class="titleright">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/usercenter/usermessage' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item v-for="(item,index) in mbx" :key="index" :to="item.path">{{item.name}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			titlename: String,
			titlecontent: String,
			mbx: Array
		},
		data() {
			return {
				mbxs:[]
			}
		},
		watch:{
			mbx(val){
				this.mbxs = val
			}
		}
	}
</script>

